// extracted by mini-css-extract-plugin
module.exports = {"reminderButton":"jgp-PkXA-"};